// assets/scripts/js/main.js

// ------------------------------------------------------------
// ✅ Load CSS (only place in your entire theme that imports CSS)
// ------------------------------------------------------------

// 1) Vendor styles first (Swiper)
import 'swiper/css/bundle'; // includes core, navigation, pagination, etc.

// 2) Your theme styles last (these override Swiper)
import '../../styles/scss/style.scss';

// ------------------------------------------------------------
// ✅ Foundation + jQuery setup
// ------------------------------------------------------------
import $ from 'jquery';
import 'foundation-sites';

// Foundation init
$(document).ready(function () {
  $(document).foundation();
});

// ------------------------------------------------------------
// ✅ Header shrink on scroll
// ------------------------------------------------------------
let lastScrollTop = 0;

$(document).on('scroll', function () {
  const scrollTop = $(this).scrollTop();
  const $masthead = $('#masthead');

  // At the very top → transparent
  if (scrollTop <= 0) {
    $masthead.removeClass('pinned scrolling-up').addClass('at-top');
  } else {
    $masthead.removeClass('at-top');

    // Scrolling down
    if (scrollTop > lastScrollTop) {
      $masthead.addClass('pinned').removeClass('scrolling-up');
    } 
    // Scrolling up
    else if (scrollTop < lastScrollTop) {
      $masthead.addClass('pinned scrolling-up');
    }
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});

// ------------------------------------------------------------
// ✅ Diagnostic (optional, safe to keep or remove)
// ------------------------------------------------------------
console.log('Webpack is working!');